import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../Services/services/auth.service';
import { Router } from '@angular/router';
import { UserAuthManager } from '../../Services/user-sessions/user-auth-manager';
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
})
export class AdminDashboardComponent implements OnInit {
  @Output() EnableMenus: EventEmitter<any> = new EventEmitter();
  id: string | null;
  constructor(private router: Router, private authService: AuthService) {
    UserAuthManager.userSessionLogout.subscribe(() => {
      this.signOut();
    });
  }

  ngOnInit(): void {
    this.id = localStorage.getItem('token');
  }

  signOut() {
    this.EnableMenus.emit(false);
    this.clickSignout();
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  signOutflag: boolean;
  clickSignout() {
    this.signOutflag = !this.signOutflag;
  }
}
